import React from "react";
import { ButtonCta, LiveChatButton } from "../ui";

const FaqCta = () => {
  return (
    <div className="px-4 py-10">
      <div className="relative mx-auto max-w-[1350px] overflow-hidden rounded-[32px] bg-gradient-to-br from-ink via-brand-900 to-ink px-6 py-16 text-center md:px-16 md:py-20">
        <div aria-hidden className="pointer-events-none absolute -left-20 -top-16 h-72 w-72 rounded-full bg-brand-500/25 blur-3xl" />
        <div aria-hidden className="pointer-events-none absolute -right-16 -bottom-16 h-72 w-72 rounded-full bg-gold/15 blur-3xl" />
        <div className="relative mx-auto max-w-3xl">
          <span className="eyebrow mx-auto flex items-center justify-center gap-3 text-gold-soft">
            <span className="h-px w-8 bg-gold/70" />
            Still Have Questions?
            <span className="h-px w-8 bg-gold/70" />
          </span>
          <h2 className="mt-5 font-display text-[clamp(1.8rem,4vw,3rem)] font-semibold leading-[1.1] text-white">
            Ready to write, publish, and sell your book worldwide?
          </h2>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <ButtonCta buttonText={"Get a Quote"} classStyle={`text-ink bg-gold hover:bg-gold-soft h-12`} />
            <LiveChatButton buttonText={"Ask a Question"} classStyle={`text-white bg-white/10 border border-white/30 backdrop-blur hover:bg-white/20 h-12`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqCta;
